module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isVisible) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeModal($event)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.amount),
      expression: "formData.amount"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "amount",
      "type": "text",
      "placeholder": "Enter amount",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.amount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.amount) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.amount))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.noteId),
      expression: "formData.noteId"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "noteId",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formData.noteId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a note")]), _vm._v(" "), _vm._l((_vm.availableNoteIds), function(noteOption, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": noteOption.noteId
      }
    }, [_vm._v("\n                  " + _vm._s(noteOption.label) + "\n                ")])
  })], 2), _vm._v(" "), (_vm.errors.noteId) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.noteId))]) : _vm._e(), _vm._v(" "), (_vm.availableNoteIds.length === 0) ? _c('span', {
    staticClass: "help-block text-warning"
  }, [_c('em', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" No notes available. Please ensure you have transactions with action taken that will reinvest.\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFundingSourceIndex),
      expression: "selectedFundingSourceIndex"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "fundingSourceType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFundingSourceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select funding source type")]), _vm._v(" "), _vm._l((_vm.fundingSources), function(fundingSource, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                  " + _vm._s(fundingSource.name) + "\n                ")])
  })], 2), _vm._v(" "), (_vm.errors.fundingSourceType) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.fundingSourceType))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.isFormValid || _vm.submitting
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.submitting ? 'Submitting...' : 'Submit') + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isVisible) ? _c('div', {
    staticClass: "modal-backdrop fade in"
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "modal-title"
  }, [_c('em', {
    staticClass: "fa fa-plus-circle text-blue"
  }), _vm._v(" Add Additional Reinvestment\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Amount "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "noteId"
    }
  }, [_vm._v("Note ID "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "fundingSourceType"
    }
  }, [_vm._v("Funding Source Type "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57d06472","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AddAdditionalReinvestment.vue
// module id = 2154
// module chunks = 1